import React, { useEffect, useRef, useState } from 'react';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import Chip from '../../../../../../_common/Chip/Chip';
import StatusField from '../../../../../../_common/StatusField/StatusField';
import { Card } from '../../PipelineComponents';
import { formattedDate } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Member', path: 'name' },
  {
    name: 'Source',
    path: 'source',
    render: (d) => (d.source
      ? (
        <div className={classes.chip_wrapper}>
          <Chip text={d.source} gray />
        </div>
      )
      : '-'),
  },
  { name: 'Follow-up', path: 'followUpDate' },
  { name: 'Owner', path: 'owner' },
  {
    name: 'Status',
    path: 'status',
    render: (d) => (d.status ? <StatusField status={d.status} /> : '-'),
  },
];

const IntakeFollowUpCard = ({ params }) => {
  const firstLoad = useRef(true);

  const [followUpData, setFollowUpData] = useState([]);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getLeadsFollowUpToday(params);

        setFollowUpData((data?.data || []).map((d) => ({
          ...d,
          name: [d.firstName, d.lastName].filter(Boolean).join(' '),
          followUpDate: formattedDate(d.followUpDate),
          owner: d.AssignedUser?.name,
        })));

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params.hub]);

  return (
    <Card
      title="Due for follow-up today"
      caption="Leads whose next contact falls today"
      loading={loading}
      firstLoad={firstLoad.current}
      isEmpty={!followUpData.length}
    >
      <div className={classes.pipeline_table}>
        <Table
          header={tableHeader}
          data={followUpData}
          notFoundText="Nothing due today"
        />
      </div>
    </Card>
  );
};

export default IntakeFollowUpCard;
